import { useEffect, useState } from "react";
import ReactStars from "react-rating-stars-component";

//scss
import "./style.scss";

//assets
import { SvgArrowLeft } from "assets/icons/js/SvgArrowLeft";
import { SvgArrowRight } from "assets/icons/js/SvgArrowRight";

//helpers
import getRatingComment from "helpers/getRatingComment";

//components
import Review from "components/ListingNew/ListingNormal/Review";
import RatingProgress from "../RatingProgress";

import clevertap from "clevertap-web-sdk";
import parseHTML from "helpers/parseHTML";
import Modal from "components/LoginAndRegister/Modal";
import { useMediaQuery } from "customHooks/useMediaQuery";
import { useTheme } from "components/ListingNew/ListingTheme";

const ListingReviews = ({ isMobile, reviewsData, ratingData, data, color }) => {
	const [reviewPage, setReviewPage] = useState(1);
	const perPage = 4;
	const totalPages = getTotalPages(reviewsData, perPage);
	const ratingList = data?.data?.rating_obj;
	const rating = ratingList.all_rating_obj;
	const nanCheck =
		isNaN(rating.overall / ratingList.review) === true
			? 0
			: +(rating.overall / ratingList.review);

	const reviewSummary = JSON.parse(
		data?.data?.sleeping_and_spotlist?.spot_info?.review_summary || null,
	);
	const [selectTag, setSelectTag] = useState("");
	const [showMore, setShowMore] = useState(false);
	const [moreCount, setMoreCount] = useState(4);

	const getSpecificReview = (id) => {
		return reviewsData?.filter((ele) => ele.booking_id === id)[0];
	};

	useEffect(() => {
		if (reviewSummary && typeof reviewSummary === "object") {
			setSelectTag(reviewSummary?.ALL_TAGS[0]);
		}
	}, []);
	useEffect(() => {
		if (moreCount >= 8) {
			setShowMore(false);
		} else {
			setShowMore(true);
		}
	}, [moreCount, selectTag]);

	const theme = useTheme();

	if (ratingData?.all_rating_obj?.overall) {
		return (
			<>
				{reviewSummary && (
					<div className="review-summary-wrapper">
						<div
							className="review-summary-header"
							style={{ color: theme.primaryTextColor }}
						>
							Guests are saying
						</div>
						<p style={{
							color : theme?.name === "xseries"? "white":"#666666"
						}} >
							{reviewSummary?.SHORT_SUMMARY_POSITIVE}
							{reviewSummary && typeof reviewSummary === "object" && (
								<span style={{ color: theme.secondaryTextColor }}>
									Summarized by AI
								</span>
							)}
						</p>
						<div className="review-summary-tags-wrapper">
							{reviewSummary?.ALL_TAGS?.map((ele) => (
								<div
									style={
										theme?.name === "xseries"
											? {
													...theme.borderBtn,
											  }
											: {
													border: selectTag === ele && "1px solid #21a221",
											  }
									}
									className="review-summary-tags"
									onClick={() => {
										setSelectTag(ele);
									}}
								>
									{theme?.name === "xseries" ? <>&#10004;</> : "✅"} {ele}
								</div>
							))}
						</div>
						{selectTag &&
							Object.values(reviewSummary?.TAG_MAPPING)?.filter((ele) =>
								ele?.includes(selectTag),
							).length !== 0 && (
								<div
									className="review-summary-box"
									style={{
										background: theme.background2,
										color: theme.baseTextColor,
									}}
								>
									<div className="review-summary-guest-header">
										{
											Object.values(reviewSummary?.TAG_MAPPING)?.filter((ele) =>
												ele?.includes(selectTag),
											).length
										}{" "}
										guests mention <b>"{selectTag}"</b>
									</div>
									<div className="review-snippets-wrapper">
										{Object.values(reviewSummary?.TAG_MAPPING)
											?.map((ele, indx) => {
												return {
													value: ele,
													id: Object.keys(reviewSummary?.TAG_MAPPING)[indx],
												};
											})
											.filter((ele) => ele.value.includes(selectTag))

											.map((ele) => (
												<ReviewSnippet
													key={ele.id}
													ele={ele}
													getSpecificReview={getSpecificReview}
													theme={theme}
												/>
											))
											.slice(
												0,

												moreCount,
											)}
										{Object.values(reviewSummary?.TAG_MAPPING)
											?.map((ele, indx) => {
												return {
													value: ele,
													id: Object.keys(reviewSummary?.TAG_MAPPING)[indx],
												};
											})
											.filter((ele) => ele.value.includes(selectTag)).length >
											4 && (
											<button
												className="show-more-btn"
												onClick={() => {
													if (showMore) {
														setMoreCount((prev) => prev + 4);
													} else {
														setMoreCount((prev) => Math.max(prev - 4, 4));
													}
												}}
											>
												{showMore ? "Show More" : "Show Less"}
											</button>
										)}
									</div>
								</div>
							)}
					</div>
				)}
				<section className="listing__reviews">
					<div className="rating">
						{/* <Rating
							rating={ratingData.all_rating_obj.overall / ratingData.review}
						/> */}
						{/* <div className="rating-comment">
							<div className="text-sm-bold clr-blue">
								{getRatingComment(ratingData.all_rating_obj.overall)}
							</div>
							<div className="text-xsm-light clr-grey">
								{`${
									reviewsData?.filter((ele) => {
										return ele.host_review_of_guest;
									}).length
								} User Reviews & ${ratingData.review} Ratings`}
							</div>
						</div> */}
						{/* <button className="listing__button">Write a Review</button> */}
						{/* {data.data.sleeping_and_spotlist?.spot_info
							?.elfsight_reviews_widget !== "nan" ? (
							<div
								dangerouslySetInnerHTML={{
									__html:
										data.data.sleeping_and_spotlist?.spot_info
											?.elfsight_reviews_widget,
								}}
							></div>
						) : null} */}
					</div>
					<div className="rating__reviews__container__wrapper">
						<div
							className="rating__reviews__container"
							style={{ background: theme.background2 }}
						>
							<div className="rating__reviews__left">
								<h3 style={{ color: theme.primaryTextColor }}>
									{(rating.overall / ratingList.review).toFixed(1)}
								</h3>
								<div className="stars__container">
									{rating.overall ? (
										<>
											<ReactStars
												size={12}
												value={nanCheck}
												activeColor={theme?.starColor}
												color="#DDDDDD"
												isHalf={true}
												edit={false}
											/>
										</>
									) : null}
									<div className="villa__rating__reviews">
										{`${
											reviewsData?.filter((ele) => {
												return ele.host_review_of_guest;
											}).length
										} User Reviews & ${ratingData.review} Ratings`}
									</div>
								</div>
							</div>
							<div className="rating__fields__normal">
								{Object.entries(ratingData?.all_rating_obj).map(
									([key, value], index) => {
										if (value / ratingData.review < 4) {
											return null;
										}
										if (key === "overall" || key === "facility") {
											return null;
										} else
											return (
												<>
													{key === "meals" &&
													(value / ratingData.review).toFixed(1) < 3 ? null : (
														<div className="rating-field" key={index}>
															{value / ratingData.review !== 0 && (
																<>
																	<div
																		className="text-sm-light"
																		style={{ color: theme.primaryTextColor }}
																	>
																		{key}
																	</div>
																	<section>
																		<RatingProgress
																			color={theme?.progressBar.background}
																			rating={value / ratingData.review}
																		/>
																		<div
																			className="text-12px-bold"
																			style={{
																				color: theme?.progressBar.color,
																			}}
																		>
																			{(value / ratingData.review).toFixed(1)}
																		</div>
																	</section>
																</>
															)}
														</div>
													)}
												</>
											);
									},
								)}
							</div>
						</div>
						{data.data.sleeping_and_spotlist?.spot_info
							?.elfsight_reviews_widget !== "nan" ? (
							<div
								dangerouslySetInnerHTML={{
									__html:
										data.data.sleeping_and_spotlist?.spot_info
											?.elfsight_reviews_widget,
								}}
							></div>
						) : null}
					</div>

					{/* <ListingToggleButtons
					buttonList={reviewsData.toggleButtonList}
					active={activePlatformButton}
					setActive={setActivePlatformButton}
				/> */}
					<hr style={{ marginTop: "20px" }} />
					<div className="reviews">
						{reviewsData
							?.map((ele) => {
								if (!ele.host_review_of_guest) {
									return {
										...ele,
										host_review_of_guest_def: `${ele.first_name} rated this home ${ele.guest_overall_rating}/5`,
									};
								}
								return ele;
							})
							.map((review, index) => {
								if (
									index < reviewPage * perPage &&
									index >= (reviewPage - 1) * perPage
								) {
									return (
										<div key={index}>
											<Review data={review} />
											<hr
												color={theme?.lineColor}
												style={{
													background: theme?.lineColor,
												}}
											/>
										</div>
									);
								}
								return null;
							})}
					</div>
					<div className="pagination">
						{!isMobile ? (
							<button
								aria-label="previous"
								className="listing__button"
								style={
									theme.background === "rgba(0, 0, 0, 1)"
										? {
												...theme?.borderBtn,
										  }
										: {}
								}
								disabled={reviewPage === 1 ? true : false}
								onClick={() => setReviewPage((prev) => prev - 1)}
							>
								Previous
							</button>
						) : (
							<SvgArrowLeft
								disabled={reviewPage === 1 ? true : false}
								onClick={() => {
									if (reviewPage > 1) setReviewPage((prev) => prev - 1);
									clevertap.event.push("review_landingPage", {
										villaId: data?.data?.listing_list?.id,
										villaName: data?.data?.listing_list?.file_reference,
										time: new Date(),
									});
								}}
							></SvgArrowLeft>
						)}
						<div className="pages">
							{reviewPage - 2 > 0 && <span className="extra-pages">...</span>}
							{totalPages > 1 &&
								[...Array(totalPages)]?.map((_, index) => {
									if (index >= reviewPage - 2 && index <= reviewPage + 2) {
										return (
											<button
												aria-label="page"
												className={
													"listing__button page text-xsm" +
													(reviewPage === index + 1 ? " selected-page" : "")
												}
												style={{
													background: theme.background,
													color: theme.baseTextColor,
												}}
												onClick={() => {
													setReviewPage(index + 1);
													clevertap.event.push("review_landingPage", {
														villaId: data?.data?.listing_list?.id,
														villaName: data?.data?.listing_list?.file_reference,
														time: new Date(),
													});
												}}
												key={index}
											>
												{index + 1}
											</button>
										);
									}
									return null;
								})}
							{reviewPage + 2 < totalPages && (
								<span className="extra-pages">...</span>
							)}
						</div>
						{!isMobile ? (
							<button
								aria-label="next"
								className="listing__button"
								style={
									theme.background === "rgba(0, 0, 0, 1)"
										? {
												...theme?.borderBtn,
										  }
										: {}
								}
								disabled={reviewPage === totalPages ? true : false}
								onClick={() => {
									setReviewPage((prev) => prev + 1);
									clevertap.event.push("review_landingPage", {
										villaId: data?.data?.listing_list?.id,
										villaName: data?.data?.listing_list?.file_reference,
										time: new Date(),
									});
								}}
							>
								Next
							</button>
						) : (
							<SvgArrowRight
								disabled={reviewPage === 1 ? true : false}
								onClick={() => {
									if (reviewPage < totalPages)
										setReviewPage((prev) => prev + 1);
									clevertap.event.push("review_landingPage", {
										villaId: data?.data?.listing_list?.id,
										villaName: data?.data?.listing_list?.file_reference,
										time: new Date(),
									});
								}}
							/>
						)}
					</div>
				</section>
			</>
		);
	} else if (
		data.data.sleeping_and_spotlist?.spot_info?.elfsight_reviews_widget
	) {
		return (
			<>
				<hr />
				<section className="listing__reviews">
					{/* <h2>Reviews</h2> */}
					{data.data.sleeping_and_spotlist?.spot_info
						?.elfsight_reviews_widget ? (
						<div
							dangerouslySetInnerHTML={{
								__html:
									data.data.sleeping_and_spotlist?.spot_info
										?.elfsight_reviews_widget,
							}}
						></div>
					) : null}
				</section>
			</>
		);
	}

	return null;
};

export default ListingReviews;

const getTotalPages = (list, perPage) => {
	return Math.ceil(list?.length / perPage);
};

const ReviewSnippet = ({ ele, getSpecificReview, theme }) => {
	const [open, setOpen] = useState(false);

	const width = useMediaQuery();

	if (
		parseHTML(getSpecificReview(ele.id.split("_")[1])?.host_review_of_guest) ===
		"undefined"
	) {
		return null;
	}
	return (
		<>
			<Modal
				shouldShow={open}
				onRequestClose={() => {
					setOpen(false);
				}}
			>
				<div className="review-modal">
					<div className="guest-details">
						<img
							src={`https://api.dicebear.com/7.x/initials/svg?seed=${
								getSpecificReview(ele.id.split("_")[1])?.first_name
							}.svg`}
							alt=""
						/>
						{getSpecificReview(ele.id.split("_")[1])?.first_name}
					</div>
					<div className="rating-details">
						{" "}
						<ReactStars
							size={14}
							value={
								getSpecificReview(ele.id.split("_")[1])?.guest_overall_rating
							}
							activeColor="#FBA919"
							color="#DDDDDD"
							isHalf={true}
							edit={false}
						/>
						{new Date(
							getSpecificReview(ele.id.split("_")[1])?.guest_review_added_on,
						).toDateString()}
					</div>
					<div className="review-content">
						{parseHTML(
							getSpecificReview(ele.id.split("_")[1])?.host_review_of_guest,
						)}
					</div>
				</div>
			</Modal>
			<div
				className="review-snippets"
				onClick={() => {
					setOpen(true);
				}}
				style={{
					color: theme?.primaryTextColor,
				}}
			>
				"
				{parseHTML(
					getSpecificReview(ele.id.split("_")[1])?.host_review_of_guest,
				).length < 200 ? (
					parseHTML(
						getSpecificReview(ele.id.split("_")[1])?.host_review_of_guest,
					)
				) : (
					<>
						{parseHTML(
							getSpecificReview(ele.id.split("_")[1])?.host_review_of_guest,
						).slice(0, width < 800 ? 100 : 200)}
						...{" "}
						<button
							style={
								theme?.name === "xseries"
									? {
											filter: "invert(1)",
									  }
									: {}
							}
						>
							Read More
						</button>
					</>
				)}
				"
			</div>
		</>
	);
};
